import React, { Fragment, Component } from "react";
import NavBar from "../../common/forms/NavbarCopy";
import { Row, Col, Container, Button, Table } from "react-bootstrap";
import { Loader } from "../../common/Loading/Loader";
import { AddNotification } from "../../Methods/Notificaition.jsx";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { subDirectory } from "../../../config.json";
import "../../../styles/BoatBookingCancellation.scss";
import { format } from "date-fns";
import { getSingleBookingIdDetails, GetCancellationReasons, getSingleCancellationDetails, getGstData, getCancellationChargesDetails, CancellationUpdate,CancellationRefundUpdate, getBookedOtherService } from "../../../services/BookingCancellationService";
import { getLocalStorageValues } from "../../../services/boat";
import $ from "jquery";
import { DropDown } from "../../forms/index";
import { Form, Radio, RadioGroup } from "informed";
import { SkSingleCancellationCard } from "../../common/skeleton/subcatCardSkeleton";
// import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import { FaInfo } from "react-icons/fa";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import paymentGatwayURI from "../../../config.json";
import http from "../../../services/httpService";
import CryptoJS from 'crypto-js';
import { getBoatHouseTiming } from "../../../services/boatListService";

const { SearchBar } = Search;

class SingleBookingCancellation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      variant: "",
      message: "",
      openNotification: false,
      SingleBookingDetails: [],
      SingleCancelDetails: [],
      CGST: "",
      SGST: "",
      Reasons: [],
      BookingId: "",
      BoatHouseId: "",
      active: false,
      CancelChargeDetails: [],
      PaymentType: "",
      TransactionNo:"",
      TrackingId:"",
      BHShortCode:"",
      RefundAmount:"",
      Charges: "",
      ChargeType: "",
      CancellationHours: "",
      Comments: "",
      isCancelDetailsLoading: true,
      isCancelDetailsAvailable: false,
      isCancelChargeLoading: true,
      isCancelChargeAvailable: false,
      isCancelAmountLoading: true,
      isCancelAmountAvailable: false,
      BookingIdList: "",
      BoatReferenceNoList: "",
      BoatReferenceData: [],
      isAlertModal: false,
      AvailableOtherService: [],
      BoatOpenTime:true,
      OtherServicesNetAmount: 0,
    };
  }

  encryptedValuesFun (value)  {
	  const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString();
	 
    if (encryptedValue) {
      return encryptedValue.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Base64 URL-safe encoding
    }
	}

  componentDidMount = async () => {
    await this.initTableData();

    console.log(this.props);

    if (this.props.location?.state) {
      await this.setState({
        BookingId: this.props.location?.state?.BookingId,
        BoatHouseId: this.props.location?.state?.BoatHouseId,
        BoatReferenceNo: this.props.location?.state?.BoatReferenceNo,
        BookingDate: this.props.location?.state?.BookingDate,
        BoatHouseName: this.props.location?.state?.BoatHouseName,
      });
    }
    await this.getGst();
    await this.getSingleBookingData();
    // await this.getSingleCancelData();
    await this.GetCancellationReasons();
    await this.getCancellationDetails();
    await this.getBookedOtherServiceDetails();
    this.setState({ isCancelDetailsLoading: false });
  };
  chargegetColumnHeaders() {
    let allKeys = ["Sl No", "HoursBefore", "Charges"];
    let excludeKeys = [];
    let keys = _.filter(allKeys, (v) => !_.includes(excludeKeys, v));
    let def = {
      "Sl No": {
        dataField: "Sl No",
        text: "Sl No ",
        sort: true,
        formatter: this.indexFormatter,
      },

      HoursBefore: {
        dataField: "ApplicableBefore",
        text: "Hours Before",
        sort: true,
      },
      Charges: {
        dataField: "Charges",

        text: "Boat Seater",
        sort: true,
      },
    };
    return { keys: keys, def: def };
  }
  ChargeinitTableData = async () => {
    const { hideColumns } = this.state;
    const columnHeaders = this.chargegetColumnHeaders();
    const chargecolumns = ChargegetColumns(columnHeaders, hideColumns);
    this.setState({ chargecolumns, columnHeaders, hideColumns });
  };
  initTableData = async () => {
    const { hideColumns } = this.state;
    const columnHeaders = this.getColumnHeaders();
    const columns = getColumns(columnHeaders, hideColumns);
    this.setState({ columns, columnHeaders, hideColumns });
  };
  indexFormatter = (cell, row, rowIndex, formatExtraData) => {
    let links = [];
    links.push(rowIndex + 1);
    return (
      <div className="actions" style={{ textAlign: "center" }}>
        {links.concat(" ")}
      </div>
    );
  };

  getColumnHeaders() {
    let allKeys = ["Sl No", "BoatTypeName", "BoatSeaterName", "BookingPin", "PremiumStatus", "InitNetAmount", "BoatDeposit", "Cancel"];
    let excludeKeys = [];
    let keys = _.filter(allKeys, (v) => !_.includes(excludeKeys, v));
    let def = {
      "Sl No": {
        dataField: "Sl No",
        text: "Sl No ",
        sort: true,
        formatter: this.indexFormatter,
      },

      BoatTypeName: {
        dataField: "BoatTypeName",
        text: "Boat Type",
        sort: true,
      },
      BoatSeaterName: {
        dataField: "BoatSeaterName",

        text: "Boat Seater",
        sort: true,
      },
      BookingPin: {
        dataField: "BookingPin",
        text: "Booking Pin ",
        sort: true,
      },
      PremiumStatus: {
        dataField: "PremiumStatus",

        text: "Premium Status",
        sort: true,
      },

      InitNetAmount: {
        dataField: "InitNetAmount",
        text: "Net Amount",
        sort: true,
      },

      BoatDeposit: {
        dataField: "BoatDeposit",
        text: "Boat Deposit",
        sort: true,
      },
      Cancel: {
        dataField: "actions",
        isDummyField: true,
        text: "Cancel",
        formatter: this.editFormatter,
      },
    };
    return { keys: keys, def: def };
  }
  editFormatter = (cell, row, rowIndex, formatExtraData) => {
    let links = [];
    console.log("this", this.state);
    // links.push(<Button type="button" className="btn btn-danger btn-sm " onClick={() => this.CancelData(row)}>Cancel</Button>);
    // links.push(<input type="checkbox" className=" " checked ={this.state.ischecked===true?true:false} onClick={(e) => this.CancelData(e, row)} />);

    links.push(<input type="checkbox" defaultChecked={this.state.SingleBookingDetails.length === 1 ? true : false} onClick={(e) => this.CancelData(e, row)} style={{ cursor: "pointer" }} />);
    return (
      <div style={{ cursor: "pointer" }} className="actions text-center" title="Edit">
        {links.concat(" ")}
      </div>
    );
  };

  CancelData = async (e, row) => {
    console.log(e, e.target.checked);
    let data = [...this.state.BoatReferenceData],
      cancellingdata = [],
      BoatReferenceNo;
    if (e.target.checked === true) {
      console.log(e.target.checked, row);
      data.push(row.BoatReferenceNo);
      await this.setState({ BoatReferenceData: data });
      BoatReferenceNo = this.state.BoatReferenceData.join(`,`);
    } else {
      console.log(e.target.checked, row);
      const removeIndex = this.state.BoatReferenceData.findIndex((item) => item == row.BoatReferenceNo);
      this.state.BoatReferenceData.splice(removeIndex, 1);
      BoatReferenceNo = this.state.BoatReferenceData.join(`,`);
    }
    console.log(this.state.BoatReferenceData, "BoatReferenceData", this.state.BoatReferenceData.join(`,`));
    await this.setState({ BoatReferenceNo: BoatReferenceNo });
    await this.getSingleCancelData(row, BoatReferenceNo);
  };

  GetCancellationReasons = async () => {
    let data = {
      TypeId: 33,
    };
    let res = await GetCancellationReasons(data);

    await this.setState({ Reasons: res.data.Response });
  };

  getSingleBookingData = async () => {
    let data = {
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
    };

    const res = await getSingleBookingIdDetails(data);
    console.log(res, "res", res.data.Response.length);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 1) {
        this.setState({ SingleBookingDetails: res.data.Response, isCancelDetailsAvailable: true });
        this.setState({ PaymentType: this.state.SingleBookingDetails[0].PaymentType });
        this.setState({ TrackingId: this.state.SingleBookingDetails[0].TrackingId });
        this.setState({ TransactionNo: this.state.SingleBookingDetails[0].TransactionNo });
        this.setState({ BHShortCode: this.state.SingleBookingDetails[0].BHShortCode });
      } else if (res.data.Response.length === 1) {
        this.setState({ SingleBookingDetails: res.data.Response, ischecked: true, isCancelDetailsAvailable: true });
        this.setState({ PaymentType: this.state.SingleBookingDetails[0].PaymentType, BoatReferenceNo: res.data.Response[0].BoatReferenceNo });
        this.setState({ TrackingId: this.state.SingleBookingDetails[0].TrackingId });
        this.setState({ TransactionNo: this.state.SingleBookingDetails[0].TransactionNo });
        this.setState({ BHShortCode: this.state.SingleBookingDetails[0].BHShortCode });
        this.getSingleCancelData(res.data.Response[0], res.data.Response[0].BoatReferenceNo);
      }
    } else {
      this.setState({ SingleBookingDetails: [], isCancelDetailsAvailable: false });
    }
  };

  getGst = async () => {
    let data = {
      ServiceId: "1",
      ValidDate: format(new Date(), "dd/MM/yyyy"),
    };

    const res = await getGstData(data);
    if (res.data.StatusCode && res.data.Response?.[0]) {
      let gstname = res.data.Response[0].TaxName;
      let gstsplit = gstname.split(",");
      let cgstarry = gstsplit[0].split("-");
      let sgstarry = gstsplit[1].split("-");
      let CGST = cgstarry[1];
      let SGST = sgstarry[1];
      await this.setState({ CGST: CGST, SGST: SGST });
    }
  };

  getCancellationDetails = async () => {
    let data = {
      BoatHouseId: this.state.BoatHouseId,
    };

    const res = await getCancellationChargesDetails(data);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({ CancelChargeDetails: res.data.Response, isCancelChargeLoading: false, isCancelChargeAvailable: true, isCancelAmountAvailable: true });
      }
    } else {
      this.setState({ CancelChargeDetails: [], isCancelChargeLoading: false, isCancelChargeAvailable: false, isCancelAmountAvailable: true });
    }
  };

  getSingleCancelData = async (rowdata, BoatReferenceNo) => {
    console.log(rowdata, BoatReferenceNo, "rowdata");
    let data = {
      ActivityType: "C",
      // BookingId: rowdata === undefined ? this.state.BookingId : rowdata.BookingId,
      BookingId: rowdata.BookingId,

      BoatHouseId: this.state.BoatHouseId,
      // "BookingId": "72-11",
      // "BoatHouseId": 72,
      Cgst: this.state.CGST,
      Sgst: this.state.SGST,
      BoatReferenceNo: BoatReferenceNo,

      // BoatReferenceNo: BoatReferenceNo === undefined ? this.state.BoatReferenceNo : BoatReferenceNo
    };

    const res = await getSingleCancellationDetails(data);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({
          SingleCancelDetails: res.data.Response,
          isCancelAmountLoading: false,
          isCancelAmountAvailable: true,
        });
        await this.state.SingleCancelDetails?.map((cancel) => {
          this.setState({
            Charges: cancel.Charges,
            ChargeType: cancel.ChargeType,
            CancellationHours: cancel.CancellationHours,
            SGSTCharges: cancel.Sgst,
            CGSTCharges: cancel.Cgst,
            RefundAmount: cancel.Refund
          });
        });
      }
    } else {
      this.setState({ SingleCancelDetails: [], isCancelAmountLoading: false, isCancelAmountAvailable: false });
    }
  };
  getBookedOtherServiceDetails = async () => {
    let data = {
      // QueryType: "SingleBookingDetails",
      QueryType: "PublicOtherService",
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
      FromDate: "",
      ToDate: "",
      UserId: "0",
      MobileNo: "0",
      RescheduleType: "",
      stgBookingPin: "",
      RescheduleOldDate: "",
      RescheduleNewDate: "",
    };
    let OtherNetAmount = 0;
    const res = await getBookedOtherService(data);
    if (res.data?.Table?.length > 0) {
      let amount = res.data.Table?.map((service) => {
        OtherNetAmount = parseFloat(parseFloat(OtherNetAmount) + parseFloat(service.NetAmount)).toFixed(2);
      });
      const resOther = await getBoatHouseTiming(data);
      let boatopenTime = resOther.data.Response[0].BookingFrom;
      let bookingDate = res.data?.Table?.[0]?.BookingDate?.split("/").reverse().join("-")
      let givenDateTime = new Date(bookingDate +"T"+boatopenTime);
      let currentDateTime = new Date();
      let OtherCancelBeforeTiming;
      if (currentDateTime < givenDateTime) {
        OtherCancelBeforeTiming = true
      }else{
        OtherCancelBeforeTiming = false
      }
      await this.setState({ AvailableOtherService: res.data.Table, 
        OtherServicesNetAmount: OtherNetAmount ,BoatOpenTime:OtherCancelBeforeTiming});
    } else {
      console.log("no booked otherservices data found for reschedule");
      this.setState({ AvailableOtherService: [], OtherServicesNetAmount: OtherNetAmount });
    }
  };
  ReasonChanges = async (e) => {
    let ReasonId = e.target.value;

    let Reasonarray = this.state.Reasons.filter((reasons) => reasons.ConfigId === ReasonId);
    let Comments = Reasonarray[0].ConfigName;
    await this.setState({ Comments: Comments });
  };

  CancelBack = () => {
    this.props.history.push({
      pathname: `${subDirectory}/boatBookingCancellation`,
    });
  };
  setFormApi = (formApi) => {
    this.formApi = formApi;
  };
  onSubmit = async () => {
    let OtherStatus = this.formApi.getValue("CancelOtherService") ? this.formApi.getValue("CancelOtherService") : "";
    if (this.state.AvailableOtherService.length > 0) {
      if (OtherStatus === "") {
        return await this.setState({
          variant: "info",
          openNotification: true,
          message: "Select Other Facilities Cancel Status",
        });
      }
    }
    let data = {
      QueryType: "CancellationUpdate",
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
      ActivityType: "C",
      Charges: this.state.Charges,
      ChargeType: this.state.ChargeType,
      Comments: this.state.Comments,
      CancelledBy: getLocalStorageValues("UserId"),
      CancelledMedia: "PW",
      CreatedBy: getLocalStorageValues("UserId"),
      Cgst: this.state.SGSTCharges,
      Sgst: this.state.CGSTCharges,
      PaymentType: this.state.PaymentType,
      // CancellationHours: this.state.CancellationHours === null ? "5" : this.state.CancellationHours,
      BookingIdList: this.state.BookingId,
      BoatReferenceNoList: this.state.BoatReferenceNo,
      CancellationType: "Customer",
      CancellationHours: "yes",
      CancelOtherService: OtherStatus,

      OtherCancelledBy: getLocalStorageValues("UserId"),
    };

    const res = await CancellationUpdate(data);

    if (res.data.StatusCode === 1) {
      let refundUpdateData ={
        BookingId: this.state.BookingId,
        BoatHouseId: this.state.BoatHouseId
      }
      const refundUpdateResponse = await CancellationRefundUpdate(refundUpdateData);
      if (refundUpdateResponse.data.statusCode === 0) {
        this.setState({
          variant: "success",
          openNotification: true,
          message: "Cancelled Successfully. The refund amount will be credited to you within 2 to 3 working days.",
        });
      }else{
        this.setState({
          variant: "error",
          openNotification: true,
          message: "Refund request was unsuccessful. Please contact the Boathouse representative for further assistance.",
        });
      }
      
      
      // const data1 = {
      //       "reference_no" : this.encryptedValuesFun(this.state.TrackingId),
      //       "refund_amount": this.encryptedValuesFun(OtherStatus === "YES" ? parseFloat(parseFloat(this.state.RefundAmount) + parseFloat(this.state.OtherServicesNetAmount)).toFixed(2) : this.state.RefundAmount),  
      //       "refund_ref_no" : this.encryptedValuesFun(this.state.TransactionNo)
      // };
      // http.post(`${paymentGatwayURI.paymentGatwayURI}/ccavRefundRequestHandler`, data1, {
      //   headers: {
      //       'Content-Type': 'application/json'
      //   }
      //   })
      //   .then(response => {
      //       console.log(response.data, "datadata");  
      //   })
      //   .catch(error => {
      //       console.error('There was a problem with the request:', error);
      //   });

      
    } else {
      this.setState({
        variant: "error",
        openNotification: true,
        message: res.data.Response,
      });
    }

    setTimeout(() => {
      this.CancelBack();
    }, 3000);
  };
  CancellationNote = () => {
    this.setState({ isAlertModal: !this.state.isAlertModal });
    this.ChargeinitTableData();
  };

  frameLoadAllBookings = () => {
    const { active, SingleBookingDetails, columns } = this.state;
    const { isCancelAmountLoading, isCancelAmountAvailable, isCancelDetailsLoading, isCancelDetailsAvailable, isCancelChargeLoading, isCancelChargeAvailable } = this.state;

    return (
      <div className="boat-cancellation my-4 mx-auto ">
        <Form getApi={this.setFormApi} onSubmit={this.onSubmit}>
          {({ formApi, formState }) => (
            <>
              {/* <div className="px-3 w-100">
                <div className="drpdwn-reason">
                  <Col md={5} className="mb-1">
                    <DropDown
                      field="Reason"
                      label="Reason for Cancellation"
                      faClass="fa fa-building"
                      className="form-control-sm payment-type mb-4"
                      optionsNames={{
                        value: "ConfigId",
                        label: "ConfigName",
                      }}
                      options={this.state.Reasons}
                      required={true}
                      validateOnBlur
                      onChange={(e) => this.ReasonChanges(e)}
                    // validate={(e) => validateProperty(true, "select", e, "Hotel")}
                    />
                  </Col>
                </div>
              </div> */}
              <div className="container2">
                <div className="row justify-content-center">
                  <div className="col-sm-12 col-md-12 col-lg-8">
                    <div className="card1">
                      {/* <img src="https://image.flaticon.com/icons/png/512/3496/3496195.png" alt="order" width="60" height="60" class="order-img" /> */}
                      <div className="bookdiv d-flex justify-content-between">
                        <div>
                          <div className=" order-nametitle">{this.state.BoatHouseName}</div>
                          <div className="order-namedate text-right">{this.state.BookingDate?.split(" ")[0]}</div>
                        </div>
                        <div>
                          <div className="order-btn" onClick={this.CancellationNote}>
                            {/* <FaInfo />  */}
                            Cancellation info
                          </div>
                          <div className="order-name text-center">Booking Id </div>
                          <div className="order-name1 text-center">{this.state.BookingId}</div>
                        </div>
                      </div>

                      <div className="common-details">
                        {this.state.active === false && (
                          <div className="booking-details">
                            {/* <div className="headerh-menu">Booking Details</div> */}
                            {isCancelDetailsLoading && <SkSingleCancellationCard />}
                            {!isCancelDetailsLoading && SingleBookingDetails && columns && (
                              <ToolkitProvider keyField="id" data={SingleBookingDetails} columns={columns} search>
                                {(props) => (
                                  <>
                                    {/* {
                                      <div className="d-flex justify-content-end w-100 px-1">
                                        <div className=" mt-2 mb-4">
                                          <SearchBar className="form-control-md" {...props.searchProps} />
                                        </div>
                                      </div>
                                    } */}
                                    <div className="tableblock">
                                      <BootstrapTable
                                        keyField="TableId"
                                        data={SingleBookingDetails}
                                        columns={columns}
                                        {...props.baseProps}
                                        bootstrap4
                                        // pagination={paginationFactory()}
                                        defaultSortDirection="asc"
                                        // striped hover condensed
                                        classes="table table-bordered table-hover"
                                        wrapperClasses="table-responsive"
                                        noDataIndication={<span className="tablenulltxt">No data to display here : </span>}
                                      />
                                    </div>
                                  </>
                                )}
                              </ToolkitProvider>
                            )}
                            {/* <table class="table-bordered bookdet-table">
                              <tbody>
                                {this.state.SingleBookingDetails.map(
                                  (bookings) =>
                                    !isCancelDetailsLoading &&
                                    isCancelDetailsAvailable && (
                                      <>
                                        <tr>
                                          <td>Booking Date</td>
                                          <td>
                                            <span>{bookings.BookingDate}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Booking Pin</td>
                                          <td>
                                            <span>{bookings.BookingPin}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Boat Type</td>
                                          <td>
                                            <span>{bookings.PremiumStatus}</span>{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Mobile No</td>
                                          <td>
                                            <span>{bookings.CustomerMobileNo}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Net Amount</td>
                                          <td>
                                            <span>₹ {bookings.InitNetAmount}</span>{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Boat Deposit</td>
                                          <td>
                                            <span>₹ {bookings.BoatDeposit}</span>
                                          </td>
                                        </tr>
                                      </>
                                    )
                                )}
                              </tbody>
                            </table> */}
                            {!isCancelDetailsLoading && this.state.AvailableOtherService.length > 0 && (
                              <div className="other-cancellation-table-container">
                                <div className="other-cancellation-list">
                                  <table class="table table-responsive cancellation-table">
                                    <thead>
                                      <tr>
                                        {/* <th>Booking Id</th> */}
                                        <th colSpan="2">Other Facilities</th>
                                        <th>No of Items</th>
                                        <th>Total Charge</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {this.state.AvailableOtherService?.map((service, i) => {
                                        return (
                                          <tr>
                                            <td colSpan="2">{service.ServiceName}</td>
                                            <td> {service.NoOfItems}</td>
                                            <td>{service.NetAmount}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="other-cancellation-container ml-2">
                                  <div className="other-cancellation-status-list">
                                    <div className=" other-facility-cancellation">Cancel Other Facilities </div>

                                    <div className="other-cancellation-selected-status">
                                      <RadioGroup field="CancelOtherService" initialValue={SingleBookingDetails.length > 1 ? "" : "YES"}>
                                        <label className="cancell-other-status mr-3">
                                          <Radio value="YES" className="other-cancell-button" /> Yes
                                        </label>
                                        <label className="cancell-other-status ">
                                          <Radio value="NO" disabled={SingleBookingDetails.length > 1 ? false : true} className="other-cancell-button" /> No
                                        </label>
                                      </RadioGroup>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* {this.state.active === true && (
                          <div className="cancellation-details">
                            <div className="headerh-menu">Cancellation Charges Details</div>
                            {isCancelAmountLoading && <SkSingleCancellationCard />}

                            <table class="fixed_header">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Hours Before</th>
                                  <th>Charges</th>
                                </tr>
                              </thead>

                              <tbody>
                                {this.state.CancelChargeDetails?.map(
                                  (canceld, i) =>
                                    !isCancelAmountLoading &&
                                    isCancelAmountAvailable && (
                                      <tr>
                                        <td>{i + 1}</td>
                                        <td>{canceld.ApplicableBefore}</td>
                                        <td>({canceld.Charges}) ₹ </td>
                                      </tr>
                                    )
                                )}
                              </tbody>
                            </table>

                            <div className="back-div" onClick={() => this.setState({ active: !this.state.active })}>
                              <BsArrowLeft className="mr-2" /> back
                            </div>
                          </div>
                        )} */}
                      </div>
                    </div>
                  </div>
                  {this.state.SingleCancelDetails.length > 0 && (
                    <div className="col-sm-12 col-md-8 col-lg-4">
                      <div className="card2">
                        <div className="order-details">
                          <div className="details-name">Cancellation Charges</div>
                          {isCancelAmountLoading && <SkSingleCancellationCard />}
                          {this.state.SingleCancelDetails.map(
                            (charges) =>
                              !isCancelAmountLoading &&
                              isCancelAmountAvailable && (
                                <Table>
                                  <tbody>
                                    <tr>
                                      <td className="charges">Boat Charges</td>
                                      <td className="chargestd"> ₹ {charges.NetAmount}</td>
                                    </tr>
                                    <tr>
                                      <td className="charges">Deposit Amount</td>
                                      <td className="chargestd"> ₹ {charges.DepositAmount}</td>
                                    </tr>
                                    {console.log({ formState })}{" "}
                                    {this.state.AvailableOtherService.length > 0 && formState.values.CancelOtherService == "YES" && (
                                      <tr>
                                        <td className="charges">Facilities Charges</td>
                                        <td className="chargestd"> ₹ {this.state.OtherServicesNetAmount}</td>
                                      </tr>
                                    )}
                                    <tr>
                                        <td className="charges">Total Amount</td>
                                        <td className="chargestd"> ₹ {parseFloat(charges.NetAmount) + parseFloat(charges.DepositAmount) + (this.state.AvailableOtherService.length > 0 && formState.values.CancelOtherService === "YES" ? parseFloat(this.state.OtherServicesNetAmount) : 0)}</td>
                                    </tr>
                                    <tr>
                                      <td className="charges">Cancel Charges</td>
                                      <td className="chargestd" style={{color:"#dc3545"}}> ₹ {charges.ChargesAmount}</td>
                                    </tr>
                                    <tr>
                                      <td className="charges1">Refund Amount</td>
                                      {formState.values.CancelOtherService == "YES" ? <td className="charges1td"> ₹ {parseFloat(parseFloat(charges.Refund) + parseFloat(this.state.OtherServicesNetAmount)).toFixed(2)}</td> : <td className="charges1td"> ₹ {charges.Refund}</td>}
                                    </tr>
                                  </tbody>
                                </Table>
                              )
                          )}
                          <div className="px-3 w-100">
                            <div className="drpdwn-reason">
                              {/* <Col md={5} className="mb-1"> */}
                              <label className="label">Reason for Cancellation</label>
                              <DropDown
                                field="Reason"
                                // label="Reason for Cancellation"
                                faClass="fa fa-building"
                                className="form-control-sm payment-type mb-4 cursor-pointer"
                                optionsNames={{
                                  value: "ConfigId",
                                  label: "ConfigName",
                                }}
                                options={this.state.Reasons}
                                required={true}
                                validateOnBlur
                                onChange={(e) => this.ReasonChanges(e)}
                                // validate={(e) => validateProperty(true, "select", e, "Hotel")}
                              />
                              {/* </Col> */}
                            </div>
                          </div>
                          <div className="query">
                            <button type="submit" className="cancelbtn">
                              Submit
                            </button>
                            {/* <button className="clearbtn" onClick={this.CancelBack}>
                            Back
                          </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </Form>
      </div>
    );
  };
  render() {
    const { columns, chargecolumns, openNotification, isCancelAmountLoading, isCancelAmountAvailable, isCancelDetailsLoading, isCancelDetailsAvailable, isCancelChargeLoading, isCancelChargeAvailable } = this.state;
    console.log(this.state, "state");
    return (
      <Fragment>
        {/* <Loader fullPage loading={false} /> */}
        <AddNotification visible={openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
        <div class="webCheckIn1">
          <NavBar {...this.props} />
          <Container fluid className="webCheckIn-con1">
            <Row className="pt-3 mb-3">
              <div className="d-flex mx-auto align-items-end " style={{ width: "90%" }}>
                <div
                  className="d-flex align-items-center  initialpage"
                  style={{ fontSize: "16px", color: "white" }}
                  onClick={() => {
                    this.props.history.push(`${subDirectory}/boatBookingCancellation`);
                  }}
                >
                  <BsArrowLeft className="mr-2" />
                  Back
                </div>
                <div className="webcheck-header1 d-flex justify-content-right">Boat Cancellation</div>
                {/* <div
                  className="d-flex align-items-end cancelhomecolor initialpage"
                  style={{ fontSize: "16px", color: "black" }}
                  onClick={() => {
                    this.props.history.push(`${subDirectory}/boatBookingCancellation`);
                  }}
                >

                  Back to Cancellation
                  <BsArrowRight className="ml-2 mr-2 mb-1" />
                </div> */}
              </div>
              {/* </Col> */}
            </Row>
            {<div>{this.frameLoadAllBookings()}</div>}
          </Container>
        </div>
        <></>
        <Modal centered isOpen={this.state.isAlertModal} toggle={this.CancellationNote} className={"alert-model"}>
          <ModalHeader toggle={this.CancellationNote} className="mchargetitle">
            Cancellation Charges Details
          </ModalHeader>
          <div className="cancellation-details">
            {/* <div className="headerh-menu-c">Cancellation Charges Details</div> */}
            {/* {isCancelAmountLoading && <SkSingleCancellationCard />} */}
            {this.state.CancelChargeDetails.length > 0 && chargecolumns && (
              <ToolkitProvider keyField="id" data={this.state.CancelChargeDetails} columns={chargecolumns} search>
                {(props) => (
                  <>
                    {/* {
                                      <div className="d-flex justify-content-end w-100 px-1">
                                        <div className=" mt-2 mb-4">
                                          <SearchBar className="form-control-md" {...props.searchProps} />
                                        </div>
                                      </div>
                                    } */}
                    <div className="Chargetableblock">
                      <BootstrapTable
                        keyField="TableId"
                        data={this.state.CancelChargeDetails}
                        columns={chargecolumns}
                        {...props.baseProps}
                        bootstrap4
                        // pagination={paginationFactory()}
                        defaultSortDirection="asc"
                        // striped hover condensed
                        classes="table chargetable-bordered table-hover"
                        wrapperClasses="table-responsive"
                        noDataIndication={<span className="tablenulltxt">No data to display here : (</span>}
                      />
                    </div>
                  </>
                )}
              </ToolkitProvider>
            )}
            {/* {this.state.CancelChargeDetails.length > 0 ? <table class="fixed_header">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Hours Before</th>
                  <th>Charges</th>
                </tr>
              </thead>

              <tbody>
                {this.state.CancelChargeDetails?.map(
                  (canceld, i) =>
                    
                    <tr>
                      <td>{i + 1}</td>
                      <td>{canceld.ApplicableBefore}</td>
                      <td>({canceld.Charges}) ₹ </td>
                    </tr>
                  // )
                )}
              </tbody>
            </table> :
              <div className="text-center">No Data</div>} */}

            {/* <div className="back-div" onClick={() => this.setState({ active: !this.state.active })}>
                              <BsArrowLeft className="mr-2" /> back
                            </div> */}
          </div>
        </Modal>
      </Fragment>
    );
  }
}
export default SingleBookingCancellation;

function getColumns(columnsHeaders, hideColumns) {
  let columns = [];
  const { keys, def } = columnsHeaders;

  _.forEach(keys, (key) => {
    columns.push({ ...def[key], hidden: _.includes(hideColumns, key) });
  });
  return columns;
}

function ChargegetColumns(columnsHeaders, hideColumns) {
  let chargecolumns = [];
  const { keys, def } = columnsHeaders;

  _.forEach(keys, (key) => {
    chargecolumns.push({ ...def[key], hidden: _.includes(hideColumns, key) });
  });
  return chargecolumns;
}


